import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import axios from 'axios';

// Configurar interceptor do Axios para adicionar tokens automaticamente
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  const integrationToken = localStorage.getItem('integrationToken');
  
  // Adicionar token de autenticação para todas as requisições
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Adicionar header de integração apenas para rotas específicas
  if (config.url.includes('/integrations/') && integrationToken) {
    config.headers['Integration-Token'] = integrationToken;
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

// Interceptor para lidar com erros de resposta
axios.interceptors.response.use(
  response => response,
  error => {
    // Lidar com erros de autenticação (401)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
